document.addEventListener("scroll", function () {
  if (window.innerWidth <= 749) {
    const header = document.getElementById('header-component');
    if (!header) return;

    if (window.scrollY > 200) {
      header.classList.add('scrolled');
    } else {
      header.classList.remove('scrolled');
    }
  }
});


document.addEventListener("DOMContentLoaded", function () {
  const trigger = document.querySelector(".custom-search-trigger");
  const searchBtn = document.querySelector(".header__icon--search");

  if (trigger && searchBtn) {
    trigger.addEventListener("click", function () {
      searchBtn.click();
    });
  }
});